/* eslint-disable no-unused-vars */
import Header from "Components/Header/Header";
import React, { useState, useRef, useEffect } from "react";
import "./ActualiteDetail.scss";
import event1 from "assets/Event1.webp";
import Footer from "Components/Footer/Footer";
import EventActuConseilRandom from "Components/EventActuConseilRandom/EventActuConseilRandom";
import { useParams } from "react-router-dom";
import { formatDate, isNotEmptyArray, sanitizeHtml } from "Services/functions";
import Loader from "Components/Loader/loader";
import { useFetchGet } from "Services/api";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import { HTMLParseOptions } from "Services/htmlParseOptions";

/**
 * Permet d'afficher la page de détail d'une actualité
 */
const ActualiteDetail = (props) => {
  // eslint-disable-next-line no-unused-vars
  const [loaderIsVisible, setLoaderIsVisible] = useState(false);
  let { id } = useParams();
  const isRecruiter = new URLSearchParams(window.location.search).get("r");
  const currentNews = useFetchGet(
    `/news/${id}${isRecruiter === "true" ? "/recruiter" : ""}`,
    props.auth.token
  );

  // remplissage de Redux avec les données des actualités
  const newsDetail = useRef(null);
  useEffect(() => {
    setLoaderIsVisible(true);
    if (newsDetail.current !== null) {
      setLoaderIsVisible(false);
      window.scroll({
        top: newsDetail.current.offsetTop,
        behavior: "smooth",
      });
    }
  }, [currentNews.loaded]);

  return (
    <div className="actualite_detail_container">
      <Header />
      <h1 className="actualite_detail_container__title h1_trait_dessus">
        Détail de l&apos;actu
      </h1>
      {currentNews && currentNews.loaded ? (
        currentNews.error ? (
          <div className="actualite_detail_container-error">
            <h1> Vous n&apos;avez pas les droits de voir cette actualité.</h1>
          </div>
        ) : (
          <div className="actualite_detail_container__top" ref={newsDetail}>
            <div className="actualite_detail_container__top__body">
              <h5 className="actualite_detail_container__top__body__categorie">
                Catégorie : {currentNews?.data?.category?.label}
              </h5>
              <h1>{currentNews?.data.title}</h1>
              <h5 className="actualite_detail_container__top__body__chapo">
                {parse(sanitizeHtml(currentNews?.data.chapo))}
              </h5>
              {currentNews.data.imageUrl || currentNews?.data?.nexusImageUrl ? (
                <img
                  src={
                    currentNews.data.nexusImageUrl
                      ? currentNews.data.nexusImageUrl
                      : `${currentNews.data.imageUrl}`
                  }
                  alt="Fond news"
                  onError={(e) => {
                    e.target.src = event1;
                  }}
                />
              ) : (
                <img src={event1} alt="Fond news" />
              )}
              <div className="actualite_detail_container__top__body__texte">
                <h5 className="actualite_detail_container__top__body__texte__date">
                  Le {formatDate(currentNews.data.publishedAt, "/")}{" "}
                  {currentNews.data.createdBy &&
                    currentNews.data.publishInMyName &&
                    `par ${currentNews.data.createdBy.firstname}`}
                </h5>
                <p className="actualite_detail_container__top__body__texte__description">
                  {parse(
                    sanitizeHtml(currentNews.data.description),
                    HTMLParseOptions
                  )}
                </p>
                {isNotEmptyArray(currentNews.data.links) && (
                  <h5 className="actualite_detail_container__top__body__texte__liens">
                    <span>Liens:</span>
                    {currentNews.data.links.map((link) => (
                      <>
                        <br />
                        <a
                          className="actualite_detail_container__top__body__texte__liens-url"
                          href={
                            // On regarde si le lien commence par http ou https
                            link.startsWith("https")
                              ? link
                              : link.startsWith("http")
                              ? link
                              : `https://${link}`
                          }
                          target="_blank"
                          rel="noreferrer"
                          key={link}
                        >
                          {link}
                        </a>
                      </>
                    ))}
                  </h5>
                )}
              </div>
            </div>
          </div>
        )
      ) : (
        <Loader />
      )}

      <div className="actualite_detail_container__bottom">
        <div className="actualite_detail_container__bottom__title">
          <h1>Autres éléments que vous pouvez consulter</h1>
        </div>
        <EventActuConseilRandom new={currentNews.data} />
        <div className="actualite_detail_container__bottom__event"></div>
      </div>
      <Footer />
    </div>
  );
};

ActualiteDetail.propTypes = {
  auth: PropTypes.object,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
});
const mapDispatchToProps = () => ({});
export default connect(mapStateToProps, mapDispatchToProps)(ActualiteDetail);
